<template>
    <div class="loyalty-temp bonus-buttons" style="flex-direction: column;">
        <a class="button secondary loyalty-request-btn" data-title="Bonus Al"   @click="code_modal = true" href="javascript:;">
            <span> Sadakat Bonusu</span>
        </a>
        <div class="code-modal" v-if="code_modal">
            <Modal :isVisible="code_modal">
                <template slot="content">
                    <div class="close-btn button primary" @click="closeCodeModal">
                        <svg xmlns="http://www.w3.org/2000/svg" height="329pt" viewBox="0 0 329.26933 329" width="329pt"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>
                    </div>
                    <h3>
                        Sadakat  Bonusu
                    </h3>
                    <div class="alert" v-for="item in loyalty.rules">{{ item }}</div>
                    
                    <ButtonLoader 
                        style="width:100%" 
                        :loader="isLoading" 
                        @click.native="onSubmit" 
                        class="button mt-1 primary" 
                        :text="'Talep Et'"
                    >
                    </ButtonLoader>
                </template>
            </Modal>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            error: '',
            code: null,
            code_modal: false,
            isLoading: false,
            step: 1,
        }
    },
    watch: {
        code_modal(val) {
            if(val){
                document.querySelector("#app").classList.add('lock');
            } else {
                document.querySelector("#app").classList.remove('lock');
            }
        }
    },
    computed: {
        loyalty() {
            return this.$store.getters['getClientConfig'].loyalty_discount_button
        }
    },
    methods: {
        closeCodeModal() {
            this.code_modal = false;
        },
        onSubmit() {
            this.isLoading = true;
            axios.post('/user/request/loyalty-module')
                .then(response => {
                    if(response.data.status){
                        this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message });
                        this.closeCodeModal();
                    } else {
                        this.$store.dispatch('alert/message', { type: 'error', msg: response.data.message });
                        this.closeCodeModal();
                    }
                })
                .catch(err => {
                    this.error = err.response.data.message 
                    this.$store.dispatch('alert/message', { type: 'error', msg: errorMsg });
                    this.closeCodeModal();
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    }
}
</script>

<style lang="scss">
    #app.mobile{
        .code-modal{
            .content{
                height: 100% !important;
                max-height: none !important;
                border-radius: 0px !important;
                .button:not(.close-btn){
                    width: 100% !important;
                }
            }
        }
    }
    .code-modal{
        position: absolute;
        .content{
            max-width: 500px !important;
            height: auto !important;
            color:#fff;
            .alert{
                text-align: left;
                background: rgb(255 255 255 / 8%);
                margin: 10px 0;
                font-weight: bold;
                span{
                    color: var(--client-c3)
                }
            }
            .close{
                display: none !important;
            }
            .button{
                height: 40px !important;
            }
            .close-btn{
                position: absolute;
                right: 10px;            
                width: 30px !important;
                top: 10px;
                border-radius: 100%;
                height: 30px !important;
                padding: 0px !important;
                svg{
                    width: 10px;
                    margin: 0px !important;
                    height: 10px;
                }    
            }
            .rules-content{
                /* Kurallar içeriği için stil */
            }
        }
    }
</style>